(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelectorAll('.carousel.slide .carousel-control-prev[data-sync], .carousel.slide .carousel-control-next[data-sync]').length) {
            return
        }

        document.querySelectorAll('.carousel.slide .carousel-control-prev[data-sync], .carousel.slide .carousel-control-next[data-sync]').forEach((control) => {
            control.addEventListener('click', () => {
                let offset = control.classList.contains('carousel-control-next') ? +1 : -1;
                let carouselElement = document.querySelector(control.getAttribute('data-sync'))

                carouselElement.Carousel.slideTo(carouselElement.Carousel.getActiveIndex() + offset)
            })
        })
    })
}) ()